import { AnalyticsClient } from './analytics.client'

export * from './analytics.types'
export const analyticsTracker = new AnalyticsClient()
